// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  updatePassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updateEmail,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  doc,
  deleteDoc,
  query,
  where,
  orderBy,
  startAfter,
  writeBatch,
  limit,
  arrayUnion,
  arrayRemove,
  onSnapshot
} from "firebase/firestore";
import { getDatabase, ref, push, onChildAdded } from "firebase/database";
import { navigate } from "svelte-routing";
import {
  apiKey,
  appId,
  messageId,
  authDomainKey,
  proyectId,
  storageBucket,
  databaseURL,
} from "./config"; // import sensible information
import { isOnetoOneMeetingsOn } from "./storage";
import { sendInvitationEmail } from "./apisSendEmail";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: apiKey,
  authDomain: authDomainKey,
  projectId: proyectId,
  databaseURL: databaseURL,
  storageBucket: storageBucket,
  messagingSenderId: messageId,
  appId: appId,
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const dbChat = getDatabase(app);
const batch = writeBatch(db);
export const auth = getAuth(app);
export { dbChat, ref, push, onChildAdded };

/* ///////////////// USER MANAGEMENT SECTION //////////////////// */

//Sign-in function
export const toSingIn = (email, password) => {
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        getSpecificDocuments("users", "email", email).then(
          async (data) => {
            
            await postDataLocal("user", data);
            navigate("/home");
            resolve(data);
          }
        );
      })
      .catch((error) => {
        getSpecificDocuments("users", "email", email)
          .then(async (data) => {
            if (data.length > 0) {
              createUserWithEmailAndPassword(auth, email, password)
                .then(async () => {
                  let dataGuardada = await postDataLocal("user", data); 
                  navigate("/home");
                })
                .catch(() =>
                  reject("Invalid login: incorrect email or password.")
                );
            }
          })
          .catch(() => reject("Invalid login: incorrect email or password."));

        // Manejar los errores específicos
        if (error.code === "auth/network-request-failed") {
          alert("Network error: Check your internet connection. ");
          reject("Network error: Check your internet connection. ");
        } else if (
          error.code === "auth/invalid-email" ||
          error.code === "auth/invalid-password" ||
          error.code === "auth/invalid-credential"
        ) {
          reject("Invalid login: incorrect email or password.");
        } else {
          console.error("Unknown error", error);
          reject("Unknown login error.");
        }
      });
  });
};

// Password recovery function
export const getResetPassword = (email) => {
  return sendPasswordResetEmail(auth, email)
    .then(() => {
      return "Email sent successfully";
    })
    .catch((error) => {
      throw error; // Propaga el error para ser manejado con .catch()
    });
};

//Function to change password
export const changePassword = (password) => {
  const user = auth.currentUser;
  return updatePassword(user, password);
  /* .then(()=>{
        alert("Password updated successfully.")
      }) */
};

//Function to change email
export const changeEmail = (email) => {
  return updateEmail(auth.currentUser, email)
    .then(() => {
      return "Email sent successfully";
    })
    .catch((error) => {
      throw error; // Propaga el error para ser manejado con .catch()
    });
};

//Function to send email for verificate the email address
export const sendEmail = () => {
  sendEmailVerification(auth.currentUser);
};

//Function to log out
export const doLogOut = () => {
  auth
    .signOut()
    .then(async () => {
      clearTableLocal("user");
      clearTableLocal("events");
      navigate("/");
      location.reload();
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage);
    });
};

/* ///////////////// SECTION FOR DATABASE MANAGEMENT //////////////////// */

/* Function to listen for changes in a specific document */
export function listenToDocument(collectionName, documentId, callback) {
  const docRef = doc(db, collectionName, documentId);

  const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
    if (docSnapshot.exists()) {
      const dataWithId = {
        id: docSnapshot.id,
        ...docSnapshot.data()
      };
      callback(dataWithId);
    } else {
      console.warn("📛 Document does not exist.");
      callback(null);
    }
  });

  return unsubscribe; // Call this to stop listening
}

/* Function to listen for changes in a complete collection */
export const listenToCollection = (collectionName, callback) => {
  const colRef = collection(db, collectionName);

  const unsubscribe = onSnapshot(colRef, (snapshot) => {
    let activeDoc = null;

    snapshot.forEach((doc) => {
      const data = doc.data();
      if (data.isActivePoll === true) {
        activeDoc = { id: doc.id, ...data };
      }
    });

    if (activeDoc && typeof callback === "function") {
      callback(activeDoc);
    }
    else{
      callback([])
    }
  });

  return unsubscribe; // Puedes usar esta función para detener el listener si lo necesitas
};

// READ DATABASES

//Function to get past events
export const getLast4PastEvents = async (collectionName) => {
  try {
    // Obtener la fecha actual en formato 'YYYY-MM-DD'
    const today = new Date().toISOString().split("T")[0];

    const q = query(
      collection(db, collectionName),
      where("eventDate.endDate", "<", today),
      orderBy("eventDate.endDate", "desc"),
      limit(4)
    );

    const querySnapshot = await getDocs(q);

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return documents;
  } catch (error) {
    console.error("❌ Error al obtener eventos pasados:", error);
    return [];
  }
};

//Function to get closest event
export const getClosestUpcomingEvent = async (collectionName) => {
  try {
    // Obtener la fecha actual en formato 'YYYY-MM-DD'
    const today = new Date().toISOString().split("T")[0];

    const q = query(
      collection(db, collectionName),
      where("eventDate.startDate", ">=", today), 
      orderBy("eventDate.startDate", "asc"),    
      limit(1)  
    );

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error("❌ Error al obtener el evento más cercano:", error);
    return null;
  }
};

export const getCollection = async (collectionData) => {
  try {
    // Fetch all documents from the collection
    const querySnapshot = await getDocs(collection(db, collectionData));

    // Extract data from each document and store in an array
    const collectionArray = querySnapshot.docs.map((doc) => doc.data());
    const id_Arrays = querySnapshot.docs.map((doc) => doc.id);
    const collectionComplete = collectionArray.map((data, index) => {
      return { ...data, id: id_Arrays[index] };
    });

    // Return the array of colections data
    return collectionComplete;
  } catch (error) {
    console.error("Error fetching data:", error);
    return []; // Return an empty array in case of error
  }
};

// Function to fetch only one document
export const getOneDocument = async (collectionData, id) => {
  let collectionComplete;
  try {
    // Fetching the documents from the collection
    const docRef = doc(db, collectionData, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      collectionComplete = { ...docSnap.data(), id };
    } else {
      // docSnap.data() will be undefined in this case
    }

    // Return the array of usuarios data
    return collectionComplete;
  } catch (error) {
    console.error("Error fetching data:", error);
    return []; // Return an empty array in case of error
  }
};

//Funciton to get the breaks name for every event
export const breaksNameFunction = async(eventName) =>{
  try {
    // Fetching the documents from the collection
    const q = query(
      collection(db, "breaks"),
      where("eventBreak", "==", eventName)
    );
    const querySnapshot = await getDocs(q);


    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Return the array of usuarios data
    return documents;
  } catch (error) {
    console.error("Error fetching data:", error);
    return []; // Return an empty array in case of error
  }
}

//Function to fetch documents from a collection and paginate them
export const getPaginatedDocuments = async (
  collectionName,
  eventName,
  pageSize,
  lastDoc = null
) => {
  try {
    let q;
    if (eventName === "") {
      q = lastDoc
        ? query(
            collection(db, collectionName),
            startAfter(lastDoc),
            limit(pageSize)
          )
        : query(collection(db, collectionName), limit(pageSize));
    } else {
      q = lastDoc
        ? query(
            collection(db, collectionName),
            /* orderBy("name"), */
            where("eventList", "array-contains", eventName),
            startAfter(lastDoc),
            limit(pageSize)
          )
        : query(
            collection(db, collectionName),
            /* orderBy("name"), */
            where("event", "==", eventName),
            limit(pageSize)
          );
    }

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { documents: [], lastDoc: null };
    }

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return {
      documents,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1], // Save last document for pagination
    };
  } catch (error) {
    console.error("Error fetching paginated documents:", error.message);
    return { documents: [], lastDoc: null };
  }
};

//Function to filter general categories
// Helper to normalize text (remove accents and convert to lowercase)
const normalizeText = (text) =>
  text
    .normalize("NFD")                 // Decompose accented characters
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .toLowerCase();
  
//Function to search meetings by name 
export const filtrarDocumentos = (documents, input) => {
  const query = normalizeText(input.trim());
  
  return documents.filter(doc => {
    // Agrupar todos los objetos de personas en un solo array, incluyendo host
    const allAttendees = [
      ...(doc.acceptedAttendees || []),
      ...(doc.declinedAttendees || []),
      ...(doc.invitedAttendees || []),
      ...(doc.host ? [doc.host] : [])
    ];
    
    return allAttendees.some(attendee => {
      const name = normalizeText(attendee.name || "");
      const surname = normalizeText(attendee.surname || "");
      return name.includes(query) || surname.includes(query);
    });
  });
}

// Function to fetch all documents and filter by a keyword in a specific property
export const searchDocumentsByKeyword = async (collectionName, property, keyword,eventName = "") => {
  try {

    const snapshot = eventName === "" ? await getDocs(collection(db, collectionName))
    :
    await getDocs(
      query(
        collection(db, collectionName),
        where("eventList", "array-contains", eventName)
      )
    );
    const normalizedKeyword = normalizeText(keyword);

    const matchingDocs = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(doc => {
        const target = doc[property];
        if (typeof target === "string") {
          return normalizeText(target).includes(normalizedKeyword);
        }
        return false;
      });

    return matchingDocs;
  } catch (error) {
    console.error("❌ Error searching documents:", error.message);
    return [];
  }
};

//Function to filter documents by a parameter
/* export const filterFuction = async (
  collectionData,
  limitNumber,
  eventName = "",
  parameter,
  value,
  lastDoc = null
) => {
  let completeCollection = [];
  try {
    let q = lastDoc
      ? query(
          collection(db, collectionData),
          where("event", "==", eventName),
          where(parameter, "==", value),
          startAfter(lastDoc),
          limit(limitNumber)
        )
      : query(
          collection(db, collectionData),
          where("event", "==", eventName),
          where(parameter, "==", value),
          limit(limitNumber)
        );

    // Fetching Data
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { documents: [], lastDoc: null };
    }

    querySnapshot.forEach((doc) => {
      completeCollection.push({ ...doc.data(), id: doc.id });
    });

    return {
      completeCollection,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1], // Last document for pagination
    };
  } catch (error) {
    console.error("Failed: ", error.code, error.message);
  }
}; */
export const filterFuction = async (
  collectionData,
  limitNumber,
  eventName = "",
  parameter,
  value,
  lastDoc = null
) => {
  let completeCollection = [];

  // Generar variaciones del valor
  const lower = value.toLowerCase();
  const upper = value.toUpperCase();
  const capitalized = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  const capitalizedEach = value
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

  const acceptedVariations = [lower, upper, capitalized, capitalizedEach];

  try {
    let q = lastDoc
      ? query(
          collection(db, collectionData),
          where("event", "==", eventName),/* 
          startAfter(lastDoc),
          limit(limitNumber) */
        )
      : query(
          collection(db, collectionData),
          where("event", "==", eventName),/* 
          limit(limitNumber) */
        );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { documents: [], lastDoc: null };
    }

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const target = data[parameter];

      if (
        typeof target === "string" &&
        acceptedVariations.includes(target)
      ) {
        completeCollection.push({ ...data, id: doc.id });
      }
    });

    return {
      completeCollection,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1],
    };
  } catch (error) {
    console.error("❌ Error in filterFuction:", error.code, error.message);
    return { documents: [], lastDoc: null };
  }
};

//Function to fetch documents from a collection and paginate them
export const getPaginatedMeetings = async (
  collectionName,
  eventName,
  pageSize,
  lastDoc = null
) => {
  try {
    let q;
    if (eventName === "") {
      q = lastDoc
        ? query(
            collection(db, collectionName),
            startAfter(lastDoc),
            limit(pageSize)
          )
        : query(collection(db, collectionName), limit(pageSize));
    } else {
      q = lastDoc
        ? query(
            collection(db, collectionName),
            where("event", "==", eventName),
            startAfter(lastDoc),
            limit(pageSize)
          )
        : query(
            collection(db, collectionName),
            where("event", "==", eventName),
            limit(pageSize)
          );
    }

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { documents: [], lastDoc: null };
    }

    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return {
      documents,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1], // Save last document for pagination
    };
  } catch (error) {
    console.error("Error fetching paginated documents:", error.message);
    return { documents: [], lastDoc: null };
  }
};

//Function to filter meetings documents by a parameter
export const filterMeetingsFuction = async (
  collectionData,
  currentEvent,
  parameter,
  value,
  lastDoc = null
) => {
  let completeCollection = [];
  try {
    let q =  query(
          collection(db, collectionData),
          where("event", "==",currentEvent),
          where(parameter, "==", value),
        )

    // Fetching Data
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { documents: [], lastDoc: null };
    }

    querySnapshot.forEach((doc) => {
      completeCollection.push({ ...doc.data(), id: doc.id });
    });

    return {
      completeCollection,
      lastDoc: querySnapshot.docs[querySnapshot.docs.length - 1], // Last document for pagination
    };
  } catch (error) {
    console.error("Failed: ", error.code, error.message);
  }
};

//Function to retrieve specific documents from the collection based on parameters.
export const getSpecificDocuments = async (
  collectionData,
  parameter,
  value
) => {
  let completeCollection = [];
  try {
    // Search for documents in the database
    const q = query(
      collection(db, collectionData),
      where(parameter, "==", value)
    );

    // Fetching Data
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // Storing data in a variable
      completeCollection.push({ ...doc.data(), id: doc.id });
    });
    return completeCollection;
  } catch (error) {
    console.error("Unable to access the documents.");
    throw error;
  }
};

//Function to read a specific number of documents
export const getLimitDocuments = async (
  collectionName,
  field,
  value,
  numDocs
) => {
  try {
    const db = getFirestore();
    const collectionRef = collection(db, collectionName);
    const q = query(collectionRef, where(field, "==", value), limit(numDocs));

    const querySnapshot = await getDocs(q);
    const documents = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return documents;
  } catch (error) {
    console.error("Error fetching documents:", error);
    return [];
  }
};

//Function to get the event closest to the current date.
export const getClosestEvent = async (currentDate, limitNumber) => {
  try {
    const q = query(
      collection(db, "events"),
      where("eventDate.startDate", ">=", currentDate),
      limit(limitNumber)
    );

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      return querySnapshot.docs.map((doc) => ({
        id: doc.id, 
        ...doc.data(),  
      }));
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error retrieving document:", error);
    return null;
  }
};

//Function to check if a document already exists in the collection.
export const documentExists = async (collectionName, fieldName, value) => {

  try {
    // Create the Firestore query
    const q = query(
      collection(db, collectionName),
      where(fieldName, "==", value)
    );
    const querySnapshot = await getDocs(q);

    // Check if there are any matching documents

    return !querySnapshot.empty; // Returns `true` if it exists, `false` if it does not exist
  } catch (error) {
    console.error("Error checking document existence:", error);
    return false; // Returns false in case of an error
  }
};
//Function to create a new document within the collection
export const postDocument = async (collectionData, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionData), data);
    return {
      success: true,
      message: "Document added successfully",
      id: docRef.id,
    };
  } catch (error) {
    console.error("❌ Error adding document:", error.message);
    return {
      success: false,
      error: error.message,
    };
  }
};
//Function to create a new document within the collection attendees
export const postAttendeeDocument = async (collectionData, data) => {
  try {
    const exists = await documentExists("users", "email", data.email);
    if (exists) {
      throw new Error("Email already exists.");
    }
    await addDoc(collection(db, collectionData), data);
    return "successfully";
  } catch (error) {
    console.error("Error: " + error.message);
    throw new Error(error.message);
  }
};

// Function to create a document with a custom ID
export const createDocumentWithID = async (collectionName, customID, data) => {  
  try {
    const docRef = doc(db, collectionName, customID); // Define the reference with the custom ID
    await setDoc(docRef, data); // Save the data in Firestore
    return `created successfully`;
  } catch (error) {
    console.error("Error creating the document:", error);
  }
};

//Function to add all Excel file documents to the database.
export const postMultipleDocuments = async (collectionData, dataArray) => {
  try {
    const collectionRef = collection(db, collectionData); // Collection reference

    // Add each object from the array to the batch.
    dataArray.forEach((data) => {
      const docRef = doc(collectionRef); // Create a new document with auto-generated ID.
      batch.set(docRef, data);
      sendInvitationEmail(data.email, "invitation", data);
    });
    // Run the batch to write everything in a single operation.
    batch.commit();
    return "All documents have been added successfully.";
  } catch (error) {
    throw error;
  }
};

// Function to update a document
export const updateDocument = async (collectionData, data, id) => {
  try {
    //Data segmentation
    const docRef = doc(db, collectionData, id);
    //Update data
    await updateDoc(docRef, data);
    return "The information has been updated successfully.";
  } catch (error) {
    throw error;
  }
};

// Function to update a document
export const updateOneDocument = async (collectionData, data, id) => {
  
  try {
    //Data segmentation
    const docRef = doc(db, collectionData, id);
    //Update data
    await updateDoc(docRef, data);
    return "updated successfully";
  } catch (error) {
    throw error;
  }
};

//Function to update multiples documents
export const updateMultipleDocuments = async (collectionName, updateData) => {
  

  if (!Array.isArray(updateData) || updateData.length === 0) {
    throw new Error("Updates must be a non-empty array");
  }

  const batch = writeBatch(db); //

  try {
    updateData.forEach(({ id, fieldName, values }) => {
      const docRef = doc(db, collectionName, id);

      if (Array.isArray(values)) {
        batch.update(docRef, { [fieldName]: arrayUnion(...values) });
      } else {
        batch.update(docRef, { [fieldName]: values });
      }
    });

    await batch.commit();
    return { success: true, message: "Batch update successful" };
  } catch (error) {
    return { success: false, error: error.message };
  }
}; 
// Function to update multiple fields for multiple documents
export const updateMultipleFieldsForMultipleDocs = async (collectionName, updateData) => {
  if (!Array.isArray(updateData) || updateData.length === 0) {
    throw new Error("Updates must be a non-empty array");
  }

  const batch = writeBatch(db);

  try {
    updateData.forEach(({ id, fields }) => {
      const docRef = doc(db, collectionName, id);

      const updatePayload = {};

      Object.entries(fields).forEach(([fieldName, value]) => {
        if (Array.isArray(value)) {
          if (value.length>0) {
            updatePayload[fieldName] = arrayUnion(...value);
          } else {
            updatePayload[fieldName] = value;
          }
        } else {
          updatePayload[fieldName] = value;
        }
      });

      batch.update(docRef, updatePayload);
    });

    await batch.commit();
    return { success: true, message: "Batch update successful" };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

//Function to delete a document from a collection
export const deleteDocument = async (collectionData, id) => {
  try {
    await deleteDoc(doc(db, collectionData, id));
    return `deleted successfully`;
  } catch (error) {
    console.error(error.message, error.code);
    throw error;
  }
};


export const deleteCustomElements = async (collectionName, deleteData) => {
  if (!Array.isArray(deleteData) || deleteData.length === 0) {
    throw new Error("Deletes must be a non-empty array");
  }

  const MAX_BATCH_SIZE = 500;
  let batches = [];
  let currentBatch = writeBatch(db);
  let operationCount = 0;

  try {
    deleteData.forEach(({ id, fieldName, values }) => {
      const docRef = doc(db, collectionName, id);

      if (!Array.isArray(values)) {
        throw new Error("Each 'values' entry must be an array to use arrayRemove.");
      }

      currentBatch.update(docRef, { [fieldName]: arrayRemove(...values) });
      operationCount++;

      if (operationCount === MAX_BATCH_SIZE) {
        batches.push(currentBatch);
        currentBatch = writeBatch(db);
        operationCount = 0;
      }
    });

    // Push the last batch if it has pending operations
    if (operationCount > 0) {
      batches.push(currentBatch);
    }

    await Promise.all(batches.map(batch => batch.commit()));
    return { success: true, message: "Batch delete successful" };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
//Function to add and delete data from multiple documents.
export const addAndDeleteMultipleDocuments = async (
  collectionName,
  deleteData,
  updateData,
  deleteObject = false
) => {
  //Empty data verification
  if (deleteData.length > 0) {
    //Data individualization
    //Delete Data
    deleteData.forEach(({ id, fieldName, values }) => {
      const docRef = doc(db, collectionName, id);
      if (deleteObject) {
        batch.update(docRef, { [fieldName]: []});
      } else {
        batch.update(docRef, { [fieldName]: arrayRemove(...values) });
      }
    });
  }
  //Empty data verification
  if (updateData.length > 0) {
    //Data individualization
    //Update Data
    updateData.forEach(({ id, fieldName, values }) => {
      const docRef = doc(db, collectionName, id);
      batch.update(docRef, { [fieldName]: arrayUnion(...values) });
    });
  }
  try {
    //Data updating
    await batch.commit();
    return { success: true, message: "Batch update successful" };
  } catch (error) {
    console.error("Error updating documents:", error);
    return { success: false, error: error.message };
  }
};

// Function to create a networkingBreak
export const createNetworkingBreak = async (collectionData, data, id) => {
  try {
    //Data segmentation
    const docRef = doc(db, collectionData, id);
    //Update data
    await updateDoc(docRef, data);
    return "Networking Break created successfully.";
  } catch (error) {    
    throw error;
  }
};

// Function to update a networkingBreak
export const updateNetworkingBreak = async (collectionData, data, id) => {
  try {
    //Data segmentation
    const docRef = doc(db, collectionData, id);
    //Update data
    await updateDoc(docRef, data);
    return "Networking Break has been updated successfully.";
  } catch (error) {
    throw error;
  }
};

// Function to delete a networkingBreak
export const deleteNetworkingBreak = async (
  collectionData,
  data,
  id,
  notification = "Networking Break"
) => {
  try {
    //Data segmentation
    const docRef = doc(db, collectionData, id);
    //Update data
    await updateDoc(docRef, data);
    return `${notification} has been deleted successfully.`;
  } catch (error) {
    throw error;
  }
};

// Function for automatic ID generation
export const idGenerator = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let idAutomatic = "";
  for (let i = 0; i < 20; i++) {
    const aleatorioIndex = Math.floor(Math.random() * characters.length);
    idAutomatic += characters[aleatorioIndex];
  }
  return idAutomatic;
};

/* ///////////////// Section to functions for user individualization and local information storage. //////////////////// */

// Functions for save data to local storage
export const postDataLocal = (tableName, data) => {
  return new Promise((resolve, reject) => {
    let dbVersion = 1; // Used to handle the database version

    // Open the database without specifying a version to get the current one
    let initialRequest = indexedDB.open("TemporalData");

    initialRequest.onsuccess = function (event) {
      let db = event.target.result;

      // If the object store already exists, proceed to save the data
      if (db.objectStoreNames.contains(tableName)) {
        db.close(); // Close the database before reopening
        saveData(); // Save the data directly
      } else {
        // If the table does not exist, increase the database version to create it
        dbVersion = db.version + 1;
        db.close(); // Close the database before updating
        createTableAndSave();
      }
    };

    initialRequest.onerror = function () {
      reject("Error opening the database");
    };

    // Function to create the table before saving the data
    function createTableAndSave() {
      let upgradeRequest = indexedDB.open("TemporalData", dbVersion);

      upgradeRequest.onupgradeneeded = function (event) {
        let db = event.target.result;

        // If the table does not exist, create it
        if (!db.objectStoreNames.contains(tableName)) {
          db.createObjectStore(tableName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };

      upgradeRequest.onsuccess = function () {
        saveData(); // After creating the table, save the data
      };

      upgradeRequest.onerror = function () {
        reject(`Error creating object store "${tableName}"`);
      };
    }

    // Function to save the data in the table
    function saveData() {
      let dbRequest = indexedDB.open("TemporalData");

      dbRequest.onsuccess = function (event) {
        let db = event.target.result;
        let transaction = db.transaction(tableName, "readwrite");
        let store = transaction.objectStore(tableName);

        let request = store.put(data); // Inserts or updates based on the `id`

        request.onsuccess = function () {
          resolve(data);
        };

        request.onerror = function () {
          console.error(`Error saving data in ${tableName}`);
          reject(`Error saving data in ${tableName}`);
        };
      };

      dbRequest.onerror = function () {
        reject("Error opening the database");
      };
    }
  });
};

// function to get data from local storage
export const getLocalData = (tableName) => {
  return new Promise((resolve, reject) => {
    let dbVersion = 1;

    // Open the database without specifying a version to get the current one
    let initialRequest = indexedDB.open("TemporalData");

    initialRequest.onsuccess = function (event) {
      let db = event.target.result;

      // Check if the object store exists before reading data
      if (db.objectStoreNames.contains(tableName)) {
        db.close(); // Close the database before reopening
        fetchData(); // Proceed to fetch data
      } else {
        // If the table does not exist, increase the database version to create it
        dbVersion = db.version + 1;
        db.close();
        createTableAndFetch();
      }
    };

    initialRequest.onerror = function () {
      reject("Error opening the database");
    };

    // Function to create the table before fetching the data
    function createTableAndFetch() {
      let upgradeRequest = indexedDB.open("TemporalData", dbVersion);

      upgradeRequest.onupgradeneeded = function (event) {
        let db = event.target.result;

        if (!db.objectStoreNames.contains(tableName)) {
          db.createObjectStore(tableName, {
            keyPath: "id",
            autoIncrement: true,
          });
        }
      };

      upgradeRequest.onsuccess = function () {
        fetchData(); // After creating the table, fetch the data
      };

      upgradeRequest.onerror = function () {
        reject(`Error creating object store "${tableName}"`);
      };
    }

    // Function to fetch data from the table
    function fetchData() {
      let dbRequest = indexedDB.open("TemporalData");

      dbRequest.onsuccess = function (event) {
        let db = event.target.result;
        let transaction = db.transaction(tableName, "readonly");
        let store = transaction.objectStore(tableName);

        let request = store.getAll();
        request.onsuccess = function () {
          resolve(request.result); // Returns the retrieved data
        };

        request.onerror = function () {
          reject(`Error retrieving data from ${tableName}`);
        };
      };

      dbRequest.onerror = function () {
        reject("Failed to open database");
      };
    }
  });
};

//Function to update data from local storage
export const updateLocalData = (tableName, data, id) => {
  return new Promise((resolve, reject) => {
    // Abrir la base de datos sin especificar versión
    let dbRequest = indexedDB.open("TemporalData");

    dbRequest.onsuccess = function (event) {
      let db = event.target.result;

      // Verificar si la tabla existe
      if (!db.objectStoreNames.contains(tableName)) {
        reject(`Error: La tabla "${tableName}" no existe.`);
        return;
      }

      let transaction = db.transaction(tableName, "readwrite");
      let store = transaction.objectStore(tableName);

      let request = store.get(id);
      request.onsuccess = function () {
        let objectData = request.result;
        if (!objectData) {
          reject(`Error: No se encontró el ID ${id} en "${tableName}".`);
          return;
        }

        // Actualizar solo los campos necesarios
        Object.assign(objectData, data);

        let updateRequest = store.put(objectData);
        updateRequest.onsuccess = function () {
          resolve(`Datos con ID ${id} actualizados en "${tableName}".`);
        };

        updateRequest.onerror = function () {
          reject(`Error al actualizar el ID ${id} en "${tableName}".`);
        };
      };

      request.onerror = function () {
        reject(`Error al obtener el ID ${id} en "${tableName}".`);
      };
    };

    dbRequest.onerror = function () {
      reject("Error al abrir la base de datos.");
    };
  });
};

//Function to delete a data object from local storage
export const clearTableLocal = () => {
  return new Promise((resolve, reject) => {
    const deleteRequest = indexedDB.deleteDatabase("TemporalData");

    deleteRequest.onsuccess = () => {
      resolve("Database deleted successfully.");
    };

    deleteRequest.onerror = (event) => {
      console.error("Error deleting database:", event.target.error);
      reject(`Error deleting database: ${event.target.error.message}`);
    };

    deleteRequest.onblocked = () => {
      console.warn(
        "Database deletion is blocked. Close all connections and try again."
      );
      reject(
        "Database deletion is blocked. Close all connections and try again."
      );
    };
  });
};

/* Functions for poll and form creation */
//Function to create a poll
export const postPollDocument = async (customID, data) => {
  try {
    const docRef = doc(db, "polls", customID); // Define the reference with the custom ID
    await setDoc(docRef, data); // Save the data in Firestore
    return `created successfully`;
  } catch (error) {
    throw error;
  }
};

//Function to retrieve specific poll documents from the collection based on parameters.
export const getSpecificPollDocuments = async (parameter, value) => {
  let completeCollection = [];
  try {
    // Search for documents in the database
    const q = query(collection(db, "polls"), where(parameter, "==", value));

    // Fetching Data
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // Storing data in a variable
      completeCollection.push({ ...doc.data(), id: doc.id });
    });
    return completeCollection;
  } catch (error) {
    console.error("Unable to access the documents.");
  }
};
//Function to delete poll document
export const deletePollDocument = async (id) => {
  try {
    await deleteDoc(doc(db, "polls", id));
    return `deleted successfully`;
  } catch (error) {
    throw error;
  }
};

// Function to update a document
export const updatePollDocument = async (data, id) => {
  try {
    //Data segmentation
    const docRef = doc(db, "polls", id);
    //Update data
    await updateDoc(docRef, data);
    return "The information has been updated successfully.";
  } catch (error) {
    throw error;
  }
};
